import { Component } from '@angular/core'
import { configurationOptionSelectors } from '../configuration-option.selectors'
import {
  catchError,
  distinctUntilChanged,
  map,
  take,
  timeout
} from 'rxjs/operators'
import { ConfigurationOptionService } from '../configuration-option.service'
import { Store } from '@ngrx/store'
import { AppState } from '../../../core/core.state'
import { Actions, ofType } from '@ngrx/effects'
import { configurationOptionActions } from '../configuration-option.actions'
import { of } from 'rxjs'
import { NotificationService } from '../../../core/notification.service'

@Component({
  selector: 'multi-day-tab',
  templateUrl: 'show.component.html'
})
export class MultiDayTabComponent {
  configFormValues$ = this.store
    .select(configurationOptionSelectors.selectAll)
    .pipe(
      distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b)),
      map((configOptions) =>
        this.configOptionService.mapEntitiesToObject(configOptions)
      )
    )

  constructor(
    private store: Store<AppState>,
    private configOptionService: ConfigurationOptionService,
    private notificationService: NotificationService,
    private actions$: Actions
  ) {}

  public onSubmit(form): void {
    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(4000),
        catchError((error) => of(null))
      )
      .subscribe((action) => {
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      })

    this.configOptionService.updateOrCreateMany(form)
  }
}
